module.exports = __webpack_public_path__ + "static/media/mertFinalProject.24dd5789.jpg";